export const DateRegexConfig = {
  "MM/DD/YYYY": /^\d{2}\/\d{2}\/\d{4}$/,
  "MM/YYYY": /^\d{2}\/\d{4}$/,
};

export const consentMapping = {
  gaming: "gaming",
  developer: "enterprise",
  enterprise: "enterprise",
  developersbusiness: "enterprise",
};
